import Image from "next/image";
import Avatar from "react-avatar";

const LogoImage = (props) => {
  return (
    <>
      {props.src && (
        <div className="avatar d-flex aling-items-center justify-center rounded-circle object-fit-cover">
          <Image
            src={props.src}
            className="rounded-circle object-fit-cover"
            alt={props.alt || "user-image"}
            width={props.width || 140}
            height={props.height || 140}
            layout="raw"
          />
        </div>
      )}

      {!props.src && props.name && (
        <div className="avatar d-flex align-items-center justify-center rounded-circle">
          <Avatar
            name={props.name}
            maxInitials={props.max_initials || 2}
            size={props.width || props.height || 140}
            round={true}
            textSizeRatio={2}
            alt={props.alt || "user-avatar"}
            // textMarginRatio={0.05}
          />
        </div>
      )}
    </>
  );
};

export default LogoImage;
